<template lang="pug">
.full-loader
  div
    loader.inner-loader
    p {{ $t('controls.parsing') }}
</template>

<script>
import loader from './Loader';

export default {
  name: 'Loader',
  components: {
    loader,
  },
  data() {
    return {
    };
  },
};
</script>

<style lang="stylus" scoped>
@import '../../assets/css/variables.styl'
.full-loader
  text-align center
  padding base-padding 0
  p
    margin-bottom 0
    font-variant small-caps
    text-transform lowercase
    &:after
      content '...'
</style>

<style lang="stylus">
.full-loader
  .inner-loader
    div
      width 20px
      height 20px
</style>



// WEBPACK FOOTER //
// src/components/partials/FullLoader.vue